import React, { useEffect } from 'react';
import './CustomAlert.css';
import xMarkIcon from '../assets/x-mark.svg';

const CustomAlert = ({
  show,
  onClose,
  type = 'success', // 'success' or 'error'
  title,
  message,
  showCloseButton = true
}) => {
  // Auto-close after 10 seconds
  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        onClose();
      }, 10000);

      return () => clearTimeout(timer);
    }
  }, [show, onClose]);

  if (!show) return null;

  const getIcon = () => {
    if (type === 'success') {
      return (
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
          <circle cx="40" cy="40" r="40" fill="#10B981" fillOpacity="0.1"/>
          <circle cx="40" cy="40" r="32" fill="#10B981"/>
          <path d="M25 40L35 50L55 30" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      );
    } else {
      return (
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
          <circle cx="40" cy="40" r="40" fill="#EF4444" fillOpacity="0.1"/>
          <circle cx="40" cy="40" r="32" fill="#EF4444"/>
          <path d="M30 30L50 50M50 30L30 50" stroke="white" strokeWidth="4" strokeLinecap="round"/>
        </svg>
      );
    }
  };

  return (
    <div className="custom-alert-overlay" onClick={onClose}>
      <div className="custom-alert-content" onClick={(e) => e.stopPropagation()}>
        {showCloseButton && (
          <button className="custom-alert-close" onClick={onClose}>
            <img src={xMarkIcon} alt="Close" width="24" height="24" />
          </button>
        )}

        <div className="custom-alert-icon">
          {getIcon()}
        </div>

        {title && <h3 className="custom-alert-title">{title}</h3>}
        {message && <p className="custom-alert-message">{message}</p>}

        <button className="custom-alert-button" onClick={onClose}>
          OK
        </button>
      </div>
    </div>
  );
};

export default CustomAlert;
